module.exports = __webpack_public_path__ + "img/logo.d35e4a87.png";